import { typeInfo } from "../../../../constants/typeInfo";

const ScrambleButton = ({
  wordList,
  currentPage,
  handleClickWord,
  type,
  key = 1,
}) => {
  return wordList.slice().map((word, index) => {
    let userAnswer;
    if (type === "analysis") {
      const scrambleElements = currentPage.data?.question
        ?.filter((element) => element.type === "scramble") || [];
      userAnswer = scrambleElements[0]?.input || [];
    } else if (type === "comprehensive" || type === "sentence") {
      userAnswer = currentPage.input || [];
    }

    const isSelected =
      userAnswer?.some((input) => input.index === word.index) || false;

    // ECHO 시안 13 — 지문분석 스크램블 칩: 선택 teal-soft / 기본 흰+line 보더
    const echoStyle = {
      fontSize: "20px",
      fontWeight: 700,
      padding: "10px 20px",
      border: currentPage.isSubmitted
        ? "1px solid #E6EDEC"
        : isSelected
        ? "1px solid #E5FBF8"
        : "1px solid #E6EDEC",
      borderRadius: "8px",
      backgroundColor: currentPage.isSubmitted
        ? "#F4F8F7"
        : isSelected
        ? "#E5FBF8"
        : "#FFFFFF",
      color: currentPage.isSubmitted
        ? "#7A8490"
        : isSelected
        ? "#00A396"
        : "#0E141B",
      cursor: "pointer",
      transition: "all 0.3s",
    };

    // 기존 스타일 — analysis 외 과제 타입은 그대로 유지
    const legacyStyle = {
      fontSize: "24px",
      padding: "12px 30px",
      border: currentPage.isSubmitted
        ? "1px solid #EBEBEB"
        : isSelected && `1px solid ${typeInfo[type].color}`,
      borderRadius: "5px",
      boxShadow: !isSelected && "0 0 5px rgba(0, 0, 0, 0.1)",
      backgroundColor: currentPage.isSubmitted
        ? "#EBEBEB"
        : isSelected && typeInfo[type].color,
      color: currentPage.isSubmitted
        ? "#737373"
        : isSelected && typeInfo[type].answerTextColor,
      transition: "all 0.3s",
    };

    return (
      <div
        key={"scramble_" + index + "_" + key}
        style={type === "analysis" ? echoStyle : legacyStyle}
        onClick={() => {
          handleClickWord(word);
        }}
      >
        {word.text}
      </div>
    );
  });
};

export default ScrambleButton;
